export default __webpack_public_path__ + "static/icon-tile-dark-828de0d766f84605ed21a8e5839f12b6495baabd1785a83a1a088815d23bc4dd.png";